import ListSuppliersAsList from '../../../../../../client/src/rfq/src/viewmodel/ListSuppliersAsListViewModel';
import { DesBaseRfq } from '../utils/des-base-rfq';

export default class DesListSuppliersAsList extends DesBaseRfq {

    constructor() {
        console.log('DesListSuppliersAsList invoked');
        super(ListSuppliersAsList);
    }

    static get observedAttributes() {
        return [ ...DesBaseRfq.observedAttributes];
    }
}
if (!window.customElements.get('des-list-suppliers-as-list')) {
    window.customElements.define('des-list-suppliers-as-list', DesListSuppliersAsList);
}
